import { ThemeProvider } from "@emotion/react";
import Loader from "@helpers/loader/loader";

import { Avatar, CssBaseline, FormControl, FormControlLabel, FormLabel, List, ListItem, ListItemAvatar, ListItemText, Radio, RadioGroup, Typography, createTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Animated } from "react-animated-css";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Cronometro } from "./Cronometro";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import Ripple from "./Ripple";
import RippleButton from "./RippleButton";

import "./cronometro.css";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { NotificationManager } from "react-notifications";

import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Assignment, BarChart, Check, Insights, Pin, Timer } from "@mui/icons-material";
import { isMobile } from "@helpers/validaciones/isMobile";
import { elFaroQueNuncaSeApagaba, preguntasFaroQueNuncaSeApaga } from "../utils/elFaroQueNuncaSeApagaba";
import { elRelojDeLaEstacionAbandonada, preguntasElRelojDeLaEstacionAbandonada } from "../utils/elRelojDeLaEstacionAbandonada";
import { laBibliotecaSinPuertas, preguntasBibliotecaSinPuertas } from "../utils/laBibliotecaSinPuertas";
import {elAjolote, cuestionarioElAjolote} from "../utils/elAjolote";
import { circuitoDeRecompensa, cuestionarioCircuitoRecompensa } from "../utils/circuitoDeRecompensa";
import { chicxulub, cuestionarioChicxulub } from "../utils/chicxulub";
import { cuestionarioLaberintoCristal, laberintoDeCristal } from "../utils/laberintoDeCristal";
import { cuestionarioMonarca, mariposaMonarca } from "../utils/mariposaMonarca";
import { cuestionarioCacao, elCacao } from "../utils/elCacao";
import { ajustarAvanceLecturaInteligente, guardarAvancesDiagnostico } from "@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura";
import { preguntasTenochtitlan, tenochtitlan } from "../utils/tenochtitlan";
import { cuestionarioMarte, marte } from "../utils/marte";
 
/**
 * -Se debe procesar la info y enviarsela al docente encargado del alumno para notificarlo
 * -En automático, se debe de ajustar el progreso del alumno en caso de que no se haya seguido el curso como se planeó.
 */


const RenderTime = ({ remainingTime }) => {
	const currentTime = useRef(remainingTime);

	const prevTime = useRef(null);

	const isNewTimeFirstTick = useRef(false);

	const [, setOneLastRerender] = useState(0);

	if (currentTime.current !== remainingTime) {
		isNewTimeFirstTick.current = true;
		prevTime.current = currentTime.current;
		currentTime.current = remainingTime;
	} else {
		isNewTimeFirstTick.current = false;
	}

	// force one last re-render when the time is over to tirgger the last animation
	if (remainingTime === 0) {
		setTimeout(() => {
			setOneLastRerender((val) => val + 1);
		}, 20);
	}

	const isTimeUp = isNewTimeFirstTick.current;

	return (
		<div className="time-wrapper">
			<div key={remainingTime} className={`time ${isTimeUp ? "up" : ""}`}>
				{remainingTime}
			</div>
			{prevTime.current !== null && (
				<div key={prevTime.current} className={`time ${!isTimeUp ? "down" : ""}`}>
					{prevTime.current}
				</div>
			)}
		</div>
	);
};

const validarCamposVacios = (objeto) => {
	for (let clave in objeto) {
		if (!objeto[clave]) {
			return true; // Si encuentra una propiedad vacía, retorna true
		}
	}
	return false; // Si no encuentra ninguna propiedad vacía, retorna false
};



const convertirSegundosAHoras = (segundos) => {
	const horas = Math.floor(segundos / 3600);
	const minutos = Math.floor((segundos % 3600) / 60);
	const segundosRestantes = segundos % 60;

	const horasFormateadas = String(horas).padStart(2, "0");
	const minutosFormateados = String(minutos).padStart(2, "0");
	const segundosFormateados = String(segundosRestantes).padStart(2, "0");

	return `${horasFormateadas}:${minutosFormateados}:${segundosFormateados}`;
};

const ExamenDiagnosticoLecturaVeloz = ({codigoExamenDiagnostico, usuarioLogeado, mostrarResultadosEvaluacion, setMostrarResultadosEvaluacion, semanaAvance, handleScrollToTop, setRealizarExamenDiagnostico}) => {
	const urlParams = new URLSearchParams(useLocation().search);

	const lightTheme = createTheme({
		palette: {
			mode: "light",
		},
	});

	const [showLoader, setShowLoader] = useState(false);

	const [mostrarCronometro, setMostrarCronometro] = useState(false);

	const [comenzarCountdown, setComenzarCountdown] = useState(false);

	const [mostrarFormulario, setMostrarFormulario] = useState(false);


	const [tiempoTranscurrido, setTiempoTranscurrido] = useState(0);

	const [numeroPalabras, setNumeroPalabras] = useState(0);

	const [tiempoUsado, setTiempoUsado] = useState(0);

	const [palabrasPorMinuto, setPalabrasPorMinuto] = useState(0);

	const [resultadoEvaluacion, setResultadoEvaluacion] = useState(0);

	const [fechaInicio, setFechaInicio] = useState(new Date());

	const [formValues, setFormValues] = useState({
		pregunta1: "",
		pregunta2: "",
		pregunta3: "",
		pregunta4: "",
		pregunta5: "",
	});

	const [texto, setTexto] = useState("");

	const [tituloTexto, setTituloTexto] = useState("");

	const [preguntas, setPreguntas] = useState([]);

	const [respetarProgreso, setRespetarProgreso] = useState(false);

	const [reiniciarProgreso, setReiniciarProgreso] = useState(false);

	const [ajustarProgreso, setAjustarProgreso] = useState(false);

	const ppmPorSemana = {
		1: 360,
		2: 425,
		3: 490,
		4: 560,
		5: 630,
		6: 700,
		7: 770,
		8: 850,
		9: 930,
		10: 1010,
		11: 1080,
		12: 1140,
		13: 1180,
		14: 1200
	}

	const ielTable = [
  { week: 1, minScore: 255 },
  { week: 2, minScore: 301 },
  { week: 3, minScore: 371 },
  { week: 4, minScore: 420 },
  { week: 5, minScore: 504 },
  { week: 6, minScore: 560 },
  { week: 7, minScore: 654 },
  { week: 8, minScore: 722 },
  { week: 9, minScore: 837 },
  { week: 10, minScore: 909 },
  { week: 11, minScore: 1026 },
  { week: 12, minScore: 1083 },
  { week: 13, minScore: 1180 },
  { week: 14, minScore: 1200 }
];


	// const calcularSemanaPorPPM = (ppm) => {
	// 	for (let semana = 1; semana <= 14; semana++) {
	// 		if (ppm <= ppmPorSemana[semana]) {
	// 		return semana
	// 		}
	// 	}
	// 	return 14;
	// }

	//TODO: Agregar las evaluaciones para poder resetear o no la info del usuario en BD.

	const evaluarFormulario = (respuestas, preguntas) => {
		try {
			const maximoAciertos = preguntas.length;

			let numeroAciertos = 0;

		
			for (const respuesta in respuestas) {
				if (Object.hasOwnProperty.call(respuestas, respuesta)) {
					const respuestaUsuario = respuestas[respuesta];

					const pregunta = preguntas.find((pregunta) => pregunta.id === respuesta);

					if (pregunta.respuesta === respuestaUsuario) {
						numeroAciertos++;
					}
				}
			}

			let porcentajeResultado = Math.round((numeroAciertos * 100) / maximoAciertos)

			return {
				porcentaje: porcentajeResultado,
				numeroAciertos
			};
		} catch (error) {
			console.log("error al evaluar el formulario: ", error);
		}
	};

	const obtenerTiempoTranscurrido = (tiempo) => {
		setTiempoTranscurrido(tiempo);
	};

	const handlePlayCronometro = () => {
		setComenzarCountdown(true);
	};

	const handleSeleccionRespuesta = ({ target }) => {
		const value = target.value;
		const name = target.name;

		setFormValues({
			...formValues,
			[name]: value,
		});
	};

	//El IEL (indice de eficencia lectora) nos ayuda a separar a los lectores que solo escanean de los que realmente procesan la informacion
	const obtenerIEL = (palabrasObtenidas, tiempoEvaluacion, aciertosEvaluacion) =>{
		console.log(tiempoEvaluacion);
		// const segundosEmpleados = tiempoEvaluacion.split(":").reduce((acc, t, i) => acc + t * [3600,60,1][i], 0);

		const IEL = ((palabrasObtenidas * 60) / tiempoEvaluacion) * (aciertosEvaluacion / preguntas.length)

		return IEL;

	}

	const obtenerSemanaAjustada = (IEL) => {
		let week = 0;

		for (const row of ielTable) {
			if (IEL >= row.minScore) {
			week = row.week;
			} else {
			break;
			}
		}

		return week; // 0 si no alcanza ni la semana 1
	}

	const revisarYAjustarResultados = async(iel, semanaActual, ppm, resultadoEvaluacion) => {
		let cursoReseteado = 0;
		let cursoAjustado = 0;
		let cursoRespetado = 0;

		switch (true) {
			case semanaActual <= 4:
					console.log(iel);
					if(iel > 300 && iel <= 504){
						//Se evalua si se respeta el progreso..
						console.log("Entra en el primer rango de iel");
						setRespetarProgreso(true);
						cursoRespetado = 1;
					}else{
						//reinicio de curso
						setReiniciarProgreso(true);
						cursoReseteado = 1;
						const semanaNueva = obtenerSemanaAjustada(iel);
						await ajustarAvanceLecturaInteligente({
							reiniciarProgreso: 1,
							semanaAjustada: semanaNueva,
							semanaAvance,
							email: usuarioLogeado.correo
						})
					}
				break;
			case semanaActual > 4 && semanaActual <= 10:
					console.log(iel);
					if(iel > 504 && iel <= 1026 ){
						//Se evalua si se respeta el progreso o se reinicia.
						//Validar si se lee mas o menos 35%, en caso de que sea <35% menos que lee, se ajusta el nivel al  acorde a ese calculo.
						//si lee mas de 35% se le reinicia el curso.
						const mas35 = iel * 1.35;
						const menos35 = iel * 0.65;

						if(iel < menos35) {
							//se ajusta a la semana que se acerque a ese iel
							console.log('Se ajusta el progreso a una semana correspondiente');
							setAjustarProgreso(true);
							cursoAjustado = 1;

							const semanaNueva = obtenerSemanaAjustada(iel);
							await ajustarAvanceLecturaInteligente({
								ajustarProgreso: 1,
								semanaAjustada: semanaNueva,
								semanaAvance,
								email: usuarioLogeado.correo
							})

						}else if (iel > mas35) {
							//se reinicia el curso
							console.log('Se reinicia el curso');
							setReiniciarProgreso(true);
							cursoReseteado = 1;

							const semanaNueva = obtenerSemanaAjustada(iel);
							await ajustarAvanceLecturaInteligente({
								reiniciarProgreso: 1,
								semanaAjustada: semanaNueva,
								semanaAvance,
								email: usuarioLogeado.correo
							})
						}else {
							//Se le respeta el progreso al alumno.
							console.log('Se respeta el progreso del curso');
							setRespetarProgreso(true);
							cursoRespetado = 1;

						}

						console.log("Entra en el segundo rango de iel");

					}else{
						//reinicio de curso
					}
				break;
			case semanaActual > 10 && semanaActual <= 14:
					console.log(iel);
					if(iel > 1026 && iel <= 1200 ){

						const mas35 = iel * 1.35;
						const menos35 = iel * 0.65;

						if(iel < menos35) {
							//se ajusta a la semana que se acerque a ese iel
							console.log('Se ajusta el progreso a una semana correspondiente');
							setAjustarProgreso(true);
							cursoAjustado = 1;

							const semanaNueva = obtenerSemanaAjustada(iel);
							await ajustarAvanceLecturaInteligente({
								ajustarProgreso: 1,
								semanaAjustada: semanaNueva,
								semanaAvance,
								email: usuarioLogeado.correo
							})

						}else if (iel > mas35) {
							//se reinicia el curso
							console.log('Se reinicia el curso');
							setReiniciarProgreso(true);
							cursoReseteado = 1;

							const semanaNueva = obtenerSemanaAjustada(iel);
							await ajustarAvanceLecturaInteligente({
								reiniciarProgreso: 1,
								semanaAjustada: semanaNueva,
								semanaAvance,
								email: usuarioLogeado.correo
							})

						}else {
							//Se le respeta el progreso al alumno.
							console.log('Se respeta el progreso del curso');
							setRespetarProgreso(true);
							cursoRespetado = 1;

						}
						console.log("Entra en el tercer rango de iel");

					}else{
						//reinicio de curso
					}
				break;
		
			default:
					console.log("Error al ajustar el progreso del alumno");
					//
				break;
		}


		await guardarAvancesDiagnostico({
			nombre: usuarioLogeado.nombreCompleto,
			apellidos: usuarioLogeado.apellidos,
			idPerfil: usuarioLogeado.idPerfil,
			codigoExamen: codigoExamenDiagnostico,
			ppmObtenidas: ppm,
			comprensionObtenida: resultadoEvaluacion.porcentaje,
			avanceRestaurado: cursoReseteado,
			avanceAjustado: cursoAjustado,
			avanceRespetado: cursoRespetado,
		});

		NotificationManager.success("Tus resultados se guardaron y se han hecho los ajustes en tu curso.");

	}

	const handleSubmit = (e) => {
		e.preventDefault();
		handleScrollToTop();
		

		try {
			const camposVacios = validarCamposVacios(formValues);

			if (camposVacios) {
				return NotificationManager.error("Responde todas las preguntas para continuar");
			}

			const cantidadPalabras = texto.trim().split(/\s+/).length;

			const palabrasPorMinuto = Math.round((cantidadPalabras * 60) / tiempoTranscurrido);

			const resultadoEvaluacion = evaluarFormulario(formValues, preguntas);

			setNumeroPalabras(cantidadPalabras);

			setPalabrasPorMinuto(palabrasPorMinuto);

			setTiempoUsado(convertirSegundosAHoras(tiempoTranscurrido));

			setResultadoEvaluacion(resultadoEvaluacion.porcentaje);

			setMostrarResultadosEvaluacion(true);

			let semanaProgreso = semanaAvance; //CAMBIAR POR LA DESESTRUCTURACION DEL COMPONENTE semanaAvance.

			
			const ppmObjetivo = ppmPorSemana[semanaProgreso];

			console.log("PPM DE LA SEMANA 5: ", ppmObjetivo);

			const mas35 = ppmObjetivo * 1.35
			const menos35 = ppmObjetivo * 0.65

			console.log("PPM obtenidas: ", palabrasPorMinuto);

			const IEL = obtenerIEL(palabrasPorMinuto, tiempoTranscurrido, resultadoEvaluacion.numeroAciertos );

			revisarYAjustarResultados(IEL, semanaProgreso, palabrasPorMinuto, resultadoEvaluacion);


		} catch (error) {
			console.log("error al calcular las palabras por minuto y evaluar el formulario: ", error);
		}
	};

	const finalizarDiagnostico = () =>{
		// console.log("Finalizando diagnostico");
		// handleScrollToTop();
		// setRealizarExamenDiagnostico(false);

		window.location.reload()
	}

	useEffect(() => {

		const getLectura = () => {
			const rand = Math.floor(Math.random() * (5 - 1) + 1);

			const randAvanzados = Math.floor(Math.random() * (8 - 7) + 7);


			console.log(semanaAvance)

			console.log(rand)
			let lectura = semanaAvance >= 12 ? randAvanzados : rand;
			
			switch (lectura) {
				case 1:
					setTexto(elAjolote);
					setTituloTexto('El Ajolote: El Dios que se Niega a Morir');
					setPreguntas(cuestionarioElAjolote);
					break;

				case 2:
					setTexto(circuitoDeRecompensa);
					setTituloTexto('El circuito de la recompensa');
					setPreguntas(cuestionarioCircuitoRecompensa);
					break;

				case 3:
					setTexto(chicxulub);
					setTituloTexto('Los Osos de Agua: Los Inmortales de tu Jardín');
					setPreguntas(cuestionarioChicxulub);
					break;
				case 4:
					setTexto(laberintoDeCristal);
					setTituloTexto('El Gran Acuífero Maya: El Laberinto de Cristal');
					setPreguntas(cuestionarioLaberintoCristal);
					break;

				case 5:
					setTexto(mariposaMonarca);
					setTituloTexto('La Mariposa Monarca: El Viaje de las Generaciones');
					setPreguntas(cuestionarioMonarca);
					break;
				case 6:
					setTexto(elCacao);
					setTituloTexto('El Cacao: El Oro de los Aztecas');
					setPreguntas(cuestionarioCacao);
					break;

				case 7:
					setTexto(marte);
					setTituloTexto('Marte: El Próximo Gran Salto y sus Desafíos Mortales');
					setPreguntas(cuestionarioMarte);
					break;
				default:
					break;
			}

		}

		getLectura();
		

		setTimeout(() => {
			setShowLoader(false);
		}, 1500);
	}, []);

	return (
		<>
			{showLoader ? (
				<Loader />
			) : (
				<>
					<ThemeProvider theme={lightTheme}>
						<CssBaseline />

						<Animated animationIn="fadeIn" isVisible={true}>
								<Container fluid className={`py-0 my-3 `}>
									{/* <Typography color="#08759e" variant="h3" gutterBottom className="text-justify text-uppercase text-center">
										Test de velocidad de lectura
									</Typography>

									<Typography color="#08759e" variant="h5" gutterBottom className="text-justify text-uppercase text-center">
										Pon a prueba tus habilidades de lectura veloz con este pequeño examen de evaluación
									</Typography> */}

									

									{mostrarFormulario ? (
										<Animated animationIn="fadeIn" isVisible={true}>
											<Card style={{border: 'none'}} body className={`mt-3 align mb-5 ${ isMobile.any() ? 'w-auto' : 'w-100' }`}>
												{mostrarResultadosEvaluacion ? (
													<>

														<Row className="justify-content-center mb-5">
															<Col className="col-12 text-center mb-4">
																<h2>Resultados de la evaluación</h2>
															</Col>
															<Col className="col-12 col-lg-4">
																<List>
																	<ListItem>
																		<ListItemAvatar>
																			<Avatar>
																				<MenuBookIcon />
																			</Avatar>
																		</ListItemAvatar>
																		<ListItemText primary="Título de la lectura" secondary={tituloTexto} />
																	</ListItem>

																	<ListItem>
																		<ListItemAvatar>
																			<Avatar>
																				<Pin />
																			</Avatar>
																		</ListItemAvatar>
																		<ListItemText primary="Número de palabras" secondary={`${numeroPalabras} palabras`} />
																	</ListItem>

																	<ListItem>
																		<ListItemAvatar>
																			<Avatar>
																				<Timer />
																			</Avatar>
																		</ListItemAvatar>
																		<ListItemText primary="Tiempo usado" secondary={tiempoUsado} />
																	</ListItem>
																</List>
															</Col>

															<Col className="col-12 col-lg-4">
																<List>
																	<ListItem>
																		<ListItemAvatar>
																			<Avatar>
																				<Insights />
																			</Avatar>
																		</ListItemAvatar>
																		<ListItemText primary="Velocidad lectora" secondary={`${palabrasPorMinuto} palabras/minuto`} />
																	</ListItem>

																	<ListItem>
																		<ListItemAvatar>
																			<Avatar>
																				<Assignment />
																			</Avatar>
																		</ListItemAvatar>
																		<ListItemText primary="Comprensión lectora" secondary={`${resultadoEvaluacion} % de comprensión`} />
																	</ListItem>

																	<ListItem>
																		<ListItemAvatar>
																			<Avatar>
																				<BarChart />
																			</Avatar>
																		</ListItemAvatar>
																		<ListItemText primary="Tu progreso actual se encuentra en la semana:" secondary={`#${semanaAvance}`} />
																	</ListItem>
																	
																</List>
															</Col>

															<Col className="text-center mt-4 col-12 col-md-10 col-lg-8">


																{respetarProgreso ? (
																	<Alert variant='success'>
																		<p style={{ fontSize: "14px" }} className="text-success">
																			<span className="text-success">¡Felicidades!

																				De acuerdo con los resultados de tu evaluación, tu velocidad de lectura y nivel de comprensión lectora son adecuados para continuar con el curso Lectura Inteligente en el nivel en el que te encuentras actualmente.

																				No será necesario realizar ningún ajuste en tu progreso, por lo que podrás seguir avanzando con normalidad y aprovechando los contenidos del programa.

																			</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-success">
																			<span>Te invitamos a continuar con tu esfuerzo y compromiso para seguir mejorando tus habilidades de lectura y comprensión.</span>
																		</p>
																	</Alert>
																): null}

																{reiniciarProgreso ? (
																	<Alert variant='primary'>
																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>Gracias por realizar la evaluación.</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>Con base en tus resultados, se ha determinado que es necesario reiniciar tu progreso en el curso Lectura Inteligente para que puedas comenzar nuevamente desde el nivel que corresponde a tu velocidad de lectura y comprensión actuales.</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>Este ajuste tiene como objetivo brindarte una mejor experiencia de aprendizaje y ayudarte a fortalecer tus habilidades paso a paso, de forma adecuada y efectiva.</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>No te preocupes, este proceso está diseñado para apoyarte en tu mejora continua. Con dedicación y constancia, podrás avanzar de manera segura y lograr excelentes resultados.</span>
																		</p>
																	</Alert>
																): null}

																{ajustarProgreso ? (
																	<Alert variant='primary'>
																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>Gracias por realizar la evaluación.</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>Con base en tus resultados, se ha determinado que es necesario ajustar tu progreso en el curso Lectura Inteligente para que puedas comenzar desde el nivel que corresponde a tu velocidad de lectura y comprensión actuales.</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>Este ajuste tiene como objetivo brindarte una mejor experiencia de aprendizaje y ayudarte a fortalecer tus habilidades paso a paso, de forma adecuada y efectiva.</span>
																		</p>

																		<p style={{ fontSize: "14px" }} className="text-dark">
																			<span>No te preocupes, este proceso está diseñado para apoyarte en tu mejora continua. Con dedicación y constancia, podrás avanzar de manera segura y lograr excelentes resultados.</span>
																		</p>
																	</Alert>
																): null}
															
															</Col>

															

															<Col className="mt-4 col-12">
																<Button onClick={finalizarDiagnostico} className='btn-success'>Terminar evaluación</Button>
															</Col>
														</Row>
													</>
												) : (
													<div className="w-auto text-start mb-5">

														<Row className="justify-content-center">
															<Col lg={6}>
																<TitleDashboard title="Contesta las siguientes preguntas" />
																<Form className="mt-4" onSubmit={handleSubmit}>
																	<Row className="d-flex">
																		{preguntas.map((pregunta, idx) => (
																			<Col key={idx} xs={12} className="mb-3">
																				<FormControl>
																					<FormLabel id={`id_${idx}`}>{pregunta.pregunta}</FormLabel>

																					<RadioGroup aria-labelledby={`id_${idx}`} name={pregunta.id} onChange={handleSeleccionRespuesta}>
																						{pregunta.opciones.map((opcion, idxOpt) => (
																							<FormControlLabel key={idxOpt} value={opcion} control={<Radio />} label={opcion} />
																						))}
																					</RadioGroup>
																				</FormControl>
																			</Col>
																		))}
																	</Row>

																	<Row className="justify-content-center">
																		<Col className="col-6">
																			<Button className="w-100" variant="primary" type="submit">
																				Enviar
																			</Button>
																			{/* <div className="d-grid gap-2">
																			</div> */}
																		</Col>
																	</Row>
																</Form>
															</Col>
														</Row>
													</div>
												)}
											</Card>
										</Animated>
									) : (
										<>
											<Row className="mt-3">
												<Col align="center">
													{
														mostrarCronometro ? (
															<Cronometro inicio={fechaInicio} obtenerTiempoTranscurrido={obtenerTiempoTranscurrido} />
														) : (
															// <Typography variant="h5" gutterBottom>
															// 	Da clic en el botón para comenzar
															// </Typography>
															null
														)
													}
												</Col>
											</Row>

											<Row className={`d-flex justify-content-center align-content-center mb-5 ${mostrarCronometro ? "" : "h-50"}`}>
												<Col>
													{mostrarCronometro ? (
														<Row className="justify-content-center">
															<Col lg={6}>
																<Typography variant="h6" gutterBottom className="text-justify text-uppercase text-center mb-4">
																	{tituloTexto}
																</Typography>
																<Animated animationIn="fadeIn" isVisible={true}>
																	<div>
																		{texto.split("\n").map((linea, index) => (
																			<Typography style={{fontSize: '14px'}} key={index} variant="body1" gutterBottom className="text-justify mb-3">
																				{linea}
																			</Typography>
																		))}

																		<div className="d-flex justify-content-center mt-4 mb-5">
																			<Button
																				onClick={() => {
																					console.log("finalizando cronometro");

																					// setFinalizarCronometro(true);

																					setMostrarFormulario(true);
																					handleScrollToTop();
																				}}
																				variant="danger">
																				Finalizar
																			</Button>
																		</div>
																	</div>
																</Animated>
															</Col>
														</Row>
													) : (
														<Animated animationIn="fadeIn" isVisible={true}>
															<Row className="d-flex justify-content-center mt-5">
																{comenzarCountdown ? (
																	<div className="timer-wrapper">
																		<CountdownCircleTimer
																			isPlaying
																			duration={3}
																			colors={["#dc3545", "#F7B801", "#198754", "#198754"]}
																			colorsTime={[3, 2, 1, 0]}
																			onComplete={() => {
																				setFechaInicio(new Date());

																				setMostrarCronometro(true);

																				setComenzarCountdown(false);
																			}}>
																			{RenderTime}
																		</CountdownCircleTimer>
																	</div>
																) : (
																	<>
																		<h4 className="mb-5">Presiona el botón para comenzar</h4>

																		<RippleButton onClick={handlePlayCronometro}>
																			<FontAwesomeIcon icon={faPlay} size="4x" color="#fd5900" />

																			<Ripple color={"#08759e"} duration={1500} />
																		</RippleButton>
																	</>
																)}
															</Row>
														</Animated>
													)}
												</Col>
											</Row>
										</>
									)}
								</Container>
						</Animated>
					</ThemeProvider>
				</>
			)}
		</>
	);
};

export default ExamenDiagnosticoLecturaVeloz;
